import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { handleDeleteDiceAlert } from "./EditCameraUtils/handleDeleteDiceAlert";

export const DeleteDiceAlertDialog = ({
  deleteDiceAlertDialogOpen,
  setDeleteDiceAlertDialogOpen,
  setBackdropLoadingScreenOn,
  diceAlerts,
  setDiceAlerts,
  setActiveTab,
  setAddDiceAlertDialogOpen,
  setSendingDiceTest,
  setDiceTestSuccessDialogOpen,
  setDiceTestFailDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  diceAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
  navigate,
}: {
  deleteDiceAlertDialogOpen: boolean;
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  diceAlerts: any;
  setDiceAlerts: Dispatcher<any>;
  setActiveTab: Dispatcher<any>;
  setAddDiceAlertDialogOpen: Dispatcher<boolean>;
  setSendingDiceTest: Dispatcher<boolean>;
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>;
  setDiceTestFailDialogOpen: Dispatcher<boolean>;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: any;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: any;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: any;
  diceAlertsOnCamera: boolean;
  sureViewAlertsOnCamera: boolean;
  siteInfo: any;
  webhooksAlertsOnCamera: boolean;
  sentinelAlertsOnCamera: boolean;
  boldAlertsOnCamera: boolean;
  patriotAlertsOnCamera: boolean;
  softguardAlertsOnCamera: boolean;
  evalinkAlertsOnCamera: boolean;
  navigate: NavigateFunction;
}) => {
  const diceAlertId = localStorage.selectedDiceAlertId;

  return (
    <Dialog open={deleteDiceAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        {" Are you sure you want to delete this Alert?"}
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDeleteDiceAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setBackdropLoadingScreenOn(true);
            handleDeleteDiceAlert(
              diceAlertId,
              diceAlerts,
              setDiceAlerts,
              setActiveTab,
              setAddDiceAlertDialogOpen,
              setSendingDiceTest,
              setDiceTestSuccessDialogOpen,
              setDiceTestFailDialogOpen,
              setDeleteDiceAlertDialogOpen,
              setBackdropLoadingScreenOn,
              sureviewAlerts,
              setAddSureviewAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              diceAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera,
              navigate
            );
            setDeleteDiceAlertDialogOpen(false);
          }}
          text="Delete Alert"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
